<template>
  <ModalDefault modal_id="emailModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_694')"
                :footer="chat.new_email.subject.length > 3"
                icon="bx bx-mail-send mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block px-2">
              <div class="col-12 pt-1 px-0">
                <div class="w-100 d-flex pt-0 px-0 mb-0 justify-content-between rounded-0 alert text-secondary">
                  <div class="d-flex py-2">
                    <div class="pl-3">
                      <div class="avatar_content" style="padding: 0 0px 0 13px;">
                        <div style="width: 50px; height: 50px;"
                             class="pl-2 avatar">
                          <img style="min-height: 50px;
                                     min-width: 50px;
                                     width: 50px;
                                     height: 50px;
                                     margin-left: -50px;
                                     z-index: 9;
                                     display: flex;
                                     border-radius: 50%;
                                     align-items: center;
                                     justify-content: center;"
                               class="avatar-img"
                               :src="(getLeadObject('id', chat.ticket.lead_id).avatar_url
                                     ? getLeadObject('id', chat.ticket.lead_id).avatar_url
                                     : lead_avatar)"/>
                          <span style="min-width: 50px;
                                     min-height: 50px;
                                     margin-left: -55px;
                                     z-index: 8;
                                     display: flex;
                                     border-radius: 50%;
                                     align-items: center;
                                     justify-content: center;
                                     background-color: #eee;"
                                class="avatar-img">
                                <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
                              </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <small>
                          {{ getTranslations('expression_695') }} <span class="title-color">{{ getLeadObject('id', chat.ticket.lead_id).name }}</span>
                        </small>
                      </div>
                      <div>
                          <span class="title-color">
                            <i class="bx bx-envelope-open"></i> {{ getLeadObject('id', chat.ticket.lead_id).email }}
                          </span>
                      </div>
                    </div>
                  </div>
                  <div class="text-right" style="align-self: center;">
                    <div v-if="chat.new_email.file" class="d-flex" style="align-items: center;">
                      <div class="pr-3">
                        <div @click="removeFileEmail()"
                             style="font-size: .7rem;"
                             class="text-danger cursor_pointer pt-1 pb-1">
                          <i class="bx bx-trash mr-1"></i>
                          <span>
                            {{ getTranslations('expression_696') }}
                          </span>
                        </div>
                        <div v-b-tooltip.bottom
                             :title="chat.new_email.filename"
                             class="text-right">
                          <small>
                            {{ chat.new_email.filename | truncate(15) }}
                          </small>
                        </div>
                      </div>
                      <div style="min-width: 55px;" class="shadow-sm">
                        <img v-if="['image/png', 'image/jpeg', 'image/jpg'].includes(chat.new_email.mimetype)"
                             :src="chat.new_email.file"
                             style="max-height: 55px;
                                 min-height: 55px;
                                 min-width: 55px;
                                 max-width: 55px;"
                             class="cursor-default">
                        <div style="max-height: 55px;
                              min-height: 55px;
                              min-width: 55px;
                              max-width: 55px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                             class="bg-light"
                             v-if="['application/pdf'].includes(chat.new_email.mimetype)">
                          <i class="bx bxs-file-pdf bx-md"></i>
                        </div>


                        <div style="max-height: 55px;
                              min-height: 55px;
                              min-width: 55px;
                              max-width: 55px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                             class="bg-light"
                             v-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(chat.new_email.mimetype)">
                          <i class="fa fa-file-word bx-md"></i>
                        </div>


                        <div style="max-height: 55px;
                              min-height: 55px;
                              min-width: 55px;
                              max-width: 55px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                             class="bg-light"
                             v-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(chat.new_email.mimetype)">
                          <i class="fa fa-file-excel bx-md"></i>
                        </div>


                        <div style="max-height: 55px;
                              min-height: 55px;
                              min-width: 55px;
                              max-width: 55px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                             class="bg-light"
                             v-if="['video/mpeg', 'video/mp4'].includes(chat.new_email.mimetype)">
                          <i class="bx bx-camera-movie bx-md"></i>
                        </div>
                      </div>
                    </div>
                    <div v-if="chat.new_email.file === null">
                      <input type="file"
                             @change.prevent="loadFileEmail()"
                             id="fileHandlerEmail"
                             multiple="multiple" hidden>
                      <div @click.stop="uploadFileEmail" class="btn btn-sm px-3 rounded-0 btn-outline-secondary shadow-sm">
                        <i class="fa fa-paperclip mr-1"></i>
                        <span>
                          {{ getTranslations('expression_530') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 pt-0 pb-0 px-0">
                <div role="alert" class="alert alert-info rounded-0 alert-dismissible">
                  <small class="d-block">
                    {{ getTranslations('expression_697') }} <b>{{ me.data.email }}</b>.
                    <br>
                    {{ getTranslations('expression_698') }}
                  </small>
                  <button type="button" data-dismiss="alert" aria-label="Close" class="close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
              <div class="col-12 pt-0 px-0">
                <label class="mt-0 mb-1">{{ getTranslations('expression_699') }}:</label>
                <div class="input-group mb-2 mt-0">
                  <input type="text"
                         v-model="chat.new_email.subject"
                         class="input_forms form-control" id="subject">
                </div>
              </div>
              <div class="col-12 pt-2 px-0">
                <wysiwyg class="" v-model="chat.new_email.text" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
            <span @click.prevent="sendEmail" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <span class="">{{ getTranslations('expression_562') }}</span>
            </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import lead_avatar from "../../assets/img/no-pic-user.png";
import Swal from "sweetalert2";
import $ from "jquery";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalChatEmail",
  components: {
    ModalDefault
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getLeadObject',
      'getChannelObject',
    ])
  },
  data(){
    return {
      lead_avatar: lead_avatar,
    }
  },
  mounted() {
    this.$root.$on('openEmail',()=> {
      this.chat.new_email.text = `<br><br><b>${ this.getTranslations('expression_894') }</b><br> <b>${this.me.data.name}</b>`
      this.chat.new_email.subject = ""
    })
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    loadFileEmail(){
      const files = document.getElementById('fileHandlerEmail')
      if(files.files && files.files[0]) {
        const file = files.files[0]
        if (['image/png',
          'image/jpeg',
          'image/jpg',
          'application/pdf',
          'video/mpeg',
          'video/mp4',
          'audio/mpeg',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ].includes(file.type)) {
          const size = (file.size / 1024) / 1024
          if (size <= 5) {
            const FR = new FileReader();
            FR.addEventListener('load', (e) => {
              this.chat.new_email.file = e.target.result
              this.chat.new_email.mimetype = file.type
              this.chat.new_email.filename = file.name
            })
            FR.readAsDataURL(file)
          } else {
            Swal.fire(
              `${ this.getTranslations('expression_683') }`,
              `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        } else {
          Swal.fire(
            `${ this.getTranslations('expression_683') }`,
            `${ this.getTranslations('expression_684') } <br/> <small>${ this.getTranslations('expression_705') }</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
            'warning'
          )
        }
      }
    },
    removeFileEmail() {
      this.chat.new_email.file = null
    },
    uploadFileEmail(){
      $('#fileHandlerEmail').click()
    },
    sendEmail(){
      const format = {
        subject: this.chat.new_email.subject,
        text: this.chat.new_email.text
      }
      this.chat.ui.row_textarea = 1
      this.chat.new_email.channel_id = this.chat.ticket.channel_id
      this.chat.new_email.ticket_id = this.chat.ticket.id
      this.chat.new_email.text = `email|${JSON.stringify(format)}`
      this.chat.new_email.operator_id = this.isOperator(this.chat.ticket.department_id)
      this.chat.new_email.department_id = this.chat.ticket.department_id
      this.$store.dispatch('sendMessage', this.chat.new_email)
      this.chat.text = "";
      this.chat.isShowEmoji = false;
      setTimeout(() => {
        this.$root.$emit('chatTextareaFocus')
        this.chat.new_email = {
          text: "",
          subject: "",
          file: null,
          mimetype: null,
          filename: null
        }
      }, 200)
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>

<style scoped>

</style>
